module.exports = __webpack_public_path__ + "static/media/adminlogo.f2ce5cfd.svg";